var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {},
    [
      _c(
        "el-row",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "home-top",
          attrs: { gutter: 40 },
        },
        [
          _c(
            "el-col",
            {
              staticClass: "home-top-col",
              attrs: { xs: 24, sm: 12, md: 8, lg: 8 },
            },
            [
              _c(
                "div",
                { staticClass: "home-top-right" },
                [
                  _c("div", { staticClass: "spaceBetween mb-60" }, [
                    _c("div", { staticClass: "home-top_text-1" }, [
                      _vm._v("Cumulative Minted Rep"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { xs: 24, sm: 12, md: 14, lg: 14 } },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "spaceLeft home-top-right_title",
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: require("@/assets/image/home/img-1.png"),
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "text-num-big",
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "baseline",
                                  },
                                },
                                [
                                  _c("big-number", {
                                    attrs: { number: _vm.total },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "home-top_text-2 ml-8",
                                      staticStyle: { "margin-left": "0.1rem" },
                                    },
                                    [_vm._v("Rep")]
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "home-top_btn",
                      staticStyle: {
                        position: "absolute",
                        bottom: "20px",
                        "text-align": "center",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.totat()
                        },
                      },
                    },
                    [_vm._v("View Details")]
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-col",
            {
              staticClass: "home-top-col",
              attrs: { xs: 24, sm: 12, md: 8, lg: 8 },
            },
            [
              _c("div", { staticClass: "home-top_left" }, [
                _c("div", { staticClass: "spaceBetween mb-60" }, [
                  _c(
                    "div",
                    {
                      staticClass: "home-top_text-1",
                      staticStyle: { color: "rgb(93, 94, 95)" },
                    },
                    [_vm._v("My Expenses")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "home-top_btn",
                      staticStyle: {
                        color: "#5D5E5F",
                        "border-radius": "1rem",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.toexpense()
                        },
                      },
                    },
                    [_vm._v("View Details\n          ")]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "home-top_text-2 mb-16",
                    staticStyle: { color: "#5D5E5F" },
                  },
                  [_vm._v("Balance")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "home-top_text-3 mb-32" }, [
                  _c(
                    "div",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "home-top_text-2 mb-16",
                          staticStyle: { color: "#5D5E5F" },
                        },
                        [_vm._v("Oil")]
                      ),
                      _vm._v(" "),
                      _c("big-number", {
                        staticStyle: { color: "#1F1C2C" },
                        attrs: { number: _vm.balance },
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "home-top_text-2",
                          staticStyle: { color: "#65646A" },
                        },
                        [_vm._v(" Unit")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "home-top_text-2 mb-16",
                          staticStyle: { color: "#5D5E5F" },
                        },
                        [_vm._v("Gas")]
                      ),
                      _vm._v(" "),
                      _c("big-number", {
                        staticStyle: { color: "#1F1C2C" },
                        attrs: { number: _vm.balance2 },
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "home-top_text-2",
                          staticStyle: { color: "#65646A" },
                        },
                        [_vm._v(" Unit")]
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _vm.expense.timestamp
                  ? _c("div", { staticClass: "home-top_text-4" }, [
                      _vm._v("The next audit is on\n          "),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm
                              .moment(_vm.expense.timestamp)
                              .format("YYYY/MM/DD")
                          )
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-col",
            {
              staticClass: "home-top-col",
              attrs: { xs: 24, sm: 12, md: 8, lg: 8 },
            },
            [
              _c("div", { staticClass: "home-top_middle" }, [
                _c("div", { staticClass: "spaceBetween mb-60" }, [
                  _c(
                    "div",
                    {
                      staticClass: "home-top_text-1",
                      staticStyle: { color: "#5D5E5F" },
                    },
                    [_vm._v("Number of Wells")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "home-top_btn",
                      staticStyle: {
                        color: "#5D5E5F",
                        "border-radius": "1rem",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.toWells()
                        },
                      },
                    },
                    [_vm._v("View Details")]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "wells-container" }, [
                  _c("div", { staticClass: "wells-numbers" }, [
                    _c("div", { staticClass: "well-item" }, [
                      _c("div", { staticClass: "well-number" }, [
                        _vm._v(_vm._s(_vm.OILTotal)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "well-label" }, [
                        _vm._v("Oil Wells"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "well-item" }, [
                      _c("div", { staticClass: "well-number" }, [
                        _vm._v(_vm._s(_vm.GASTotal)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "well-label" }, [
                        _vm._v("Gas Wells"),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "wells-progress" }, [
                    _c("div", {
                      staticClass: "well-progress-bar oil-progress",
                      style: { width: _vm.oilPercentage + "%" },
                    }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "well-progress-bar gas-progress",
                      style: { width: _vm.gasPercentage + "%" },
                    }),
                  ]),
                ]),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }